import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const returnClosedOrderToteInventory = {
  name: "returnClosedOrderToteInventory" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    destinations: z
      .array(
        z.object({
          lineId: z.string(),
          storageLocationId: storageLocationIdFormat.schema,
        }),
      )
      .optional(),
  }),
  output: z.object({ returnedQuantity: z.number() }),
};
